import { AttachmentUtil, MultipleFileUtil, FileUtil, StorageUtil } from "utils";
import { tusGet } from "./tus-get";
import { SystemConstant } from "const";
import JSZip from "jszip";
import { tusUpload } from "./tus-upload";
import store, { AttachmentActions } from "redux-store";

export const getFileFromTus = async (prefixKey, fileInfo, groupId) => {
  try {
    const remoteResponse = await tusGet(prefixKey, fileInfo.attachmentId, groupId);
    if (false === Boolean(remoteResponse)) return false;
    const remoteData = remoteResponse.data;
    const remoteFileRecord = remoteResponse.fileInfo;
    const fileType = remoteFileRecord.type;
    const isPublicFile = fileType === SystemConstant.UPLOAD_TYPE.account;

    try {
      if (remoteData) {
        const fileMetaData = fileInfo.metaData;
        const fileAesInfo = fileInfo.aesKeyInfo;

        const fileName = fileMetaData.fileName;
        const decryptFilePath = AttachmentUtil.getPath(`${remoteFileRecord.url}/${fileName}`);
        const decryptFolderPath = AttachmentUtil.getPath(remoteFileRecord.url);

        if (remoteFileRecord.version === SystemConstant.UPLOAD_FILE_VERSION.oldVersion) {
          if (isPublicFile) {
            await FileUtil.makeFolder(decryptFolderPath);
            FileUtil.writeFile(decryptFilePath, new Uint8Array(remoteData));
          } else {
            await MultipleFileUtil.decryptFile(
              new Uint8Array(remoteData),
              fileAesInfo.key,
              fileAesInfo.iv,
              fileAesInfo.authtag,
              decryptFilePath,
              fileAesInfo.encryptVersion,
              fileAesInfo.mkv256GcmF,
            );
          }
        } else {
          if (isPublicFile) {
            await FileUtil.makeFolder(decryptFolderPath);
            FileUtil.writeFile(decryptFilePath, new Uint8Array(remoteData));
          } else {
            const zip = new JSZip();
            const zipContent = await zip.loadAsync(remoteData);
            const fileEntries = Object.keys(zipContent.files);

            const { keys, ivs, authtags, key, iv, encryptVersion, mkv256GcmF } = fileAesInfo;

            for (let index = 0; index < fileEntries.length; index++) {
              const fileIndex = index + 1;
              const tempFileName = `${fileIndex}.tmp`;
              const file = zipContent.files[tempFileName];
              if (false === Boolean(file)) continue;

              const content = await file.async("arraybuffer");
              const fileOptions = {
                encoding: "utf8",
                flag: "a",
                mode: 0o666,
              };

              if (Boolean(key && iv)) {
                await MultipleFileUtil.decryptFile(
                  new Uint8Array(content),
                  key,
                  iv,
                  fileAesInfo.authtags[index],
                  decryptFilePath,
                  fileOptions,
                  fileAesInfo.encryptVersion,
                  fileAesInfo.mkv256GcmF,
                );
              } else if (Array.isArray(keys) && Array.isArray(ivs)) {
                await MultipleFileUtil.decryptFile(
                  new Uint8Array(content),
                  keys[index],
                  ivs[index],
                  authtags[index],
                  decryptFilePath,
                  fileOptions,
                  encryptVersion,
                  mkv256GcmF,
                );
              }
            }
          }
        }

        return remoteFileRecord;
      }
    } catch (_error) {
      store.dispatch(
        AttachmentActions.updateAttachmentProgress(
          fileInfo.attachmentId,
          0,
          0,
          SystemConstant.FILE_OPERATION.decryptFailed,
        ),
      );
    }
  } catch (error) {
    console.error("get file from tus error: ", error);
  }
  return null;
};

export const uploadFile = async (prefixKey, attachmentId, uploadType, groupId, callbackFuncs) => {
  prefixKey = prefixKey || StorageUtil.getCurrentPrefixKey();
  if (false === Boolean(attachmentId)) return false;
  const filePath = AttachmentUtil.getEncryptionZipPath(attachmentId);
  return await tusUpload(prefixKey, attachmentId, filePath, uploadType, groupId, callbackFuncs);
};
